export const unwrap = <T extends { success: boolean; message: string }>(response: { data: T }) => {
  const { success, message, ...rest } = response.data;

  return rest;
};

export interface ResponseDataWrapper<T> {
  data: T;
}
